import { render } from "./ErroresCarga.vue?vue&type=template&id=f5b7c57a"
import script from "./ErroresCarga.vue?vue&type=script&lang=js"
export * from "./ErroresCarga.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__